import { useEffect, useReducer } from 'react'
import services from './services'
import reducer from './reducer'

export const FPM_CS_MSG =
  'We cannot find a valid email or mobile number associated with this Link Rewards card number.'

const OTP_METHODS = [
  { key: 'maskedPhoneNumber', label: 'mobile number', channel: 'sms' },
  { key: 'maskedEmail', label: 'email address', channel: 'email' },
]

const useUnionLoginHook = ({ redirectToProfile, saveCredentials }) => {
  const initialState = {
    cardInputHelpText: null,
    currentState: 'promptPlusCard',
    otpInputHelpText: null,
    otpMethods: OTP_METHODS,
    otpNumber: '',
    plusCardNumber: '',
    redirectToProfile,
    saveCredentials,
    showCardInfoModal: false,
    showHelpBox: false,
  }

  const [state, send] = useReducer(reducer, initialState)

  useEffect(() => {
    if (Object.keys(services).some(service => service === state.currentState)) {
      services[state.currentState](state, send)
    }
  }, [state, state.currentState])

  const matches = value => value === state.currentState

  return [{ matches, state }, send]
}

export default useUnionLoginHook
